export const ContainmentInformation = "Containment Information";
export const ContainmentName = "Containment Name";
export const ContainmentType = "Containment Type";
export const Description = "Description";
export const Comments = "Comments";
export const UseSameAsDescription = "Use same as Description";
export const MccId = "MCC ID";
export const ContainmentSourceSystem = "Containment Source System";
export const HoldType = "Hold Type";
export const InitialHold = "Hold Type - On Initial Load";
export const OnInitialLoad = "On Initial Load";
export const SubsequentHold = "Hold Type - On Subsequent Scan";
export const OnSubsequentScan = "On Subsequent Scan";
export const ImpactedSectorsAndPlants = "Impacted Sectors & Plants";
export const Sectors = "Sectors";
export const Plants = "Plants";
export const PartNumbers = "Part Numbers";
export const PartNumbersImpacted = "Part Numbers Impacted";
export const PartNumber = "Part Number";
export const SupplierDuns = "Supplier DUNS";
export const UploadContentType = "Upload Content Type";
export const SinglePartLabel = "Containment only has one part number";
export const MultiplePartsLabel = "Containment has multiple part numbers";
export const SinglePartReadonly = "Single part number";
export const MultiplePartsReadonly = "Multiple part numbers";
export const Type = "Type";
export const Parts = "Parts";
export const Actions = "Actions";
export const Action = "Action";
export const LockLpns = "Lock LPNs";
export const UnlockLpns = "Unlock LPNs";
export const AddSerials = "Add Serials";
